
import type { PropType } from 'vue';

import { defineComponent } from 'vue';

import type { GenericObject } from '@/types';

export default defineComponent({
  props: {
    data: {
      type: Object as PropType<GenericObject>,
      required: true,
    },
  },
});
